import axios from 'axios';
import _ from 'lodash';

const errorHandler = err => {
  // TODO: Replace and add functionality of logger
  console.log(err);
};

export const getFaqs = async lng => {
  try {
    const faqResponse = await axios.get(`/api/faqs?locale=${lng}`, {
      withCredentials: true
    });
    if (!_.isEmpty(faqResponse.data)) {
      return faqResponse.data;
    }
  } catch (err) {
    errorHandler(err);
  }
};
